// Storage wrapper untuk Web Player.
// MVP: cuma localStorage. Phase 2: IndexedDB untuk cache media (offline-first).

const NAMESPACE = "signage:";

export const storage = {
  get(key: string): string | null {
    try {
      return localStorage.getItem(NAMESPACE + key);
    } catch {
      return null;
    }
  },
  set(key: string, value: string): void {
    try {
      localStorage.setItem(NAMESPACE + key, value);
    } catch {
      // QuotaExceededError, private mode, dll. — silent fail untuk MVP.
    }
  },
  remove(key: string): void {
    try {
      localStorage.removeItem(NAMESPACE + key);
    } catch {
      // ignore
    }
  },
  getJSON<T>(key: string): T | null {
    const raw = this.get(key);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as T;
    } catch {
      return null;
    }
  },
  setJSON<T>(key: string, value: T): void {
    this.set(key, JSON.stringify(value));
  },
};
